import { render, staticRenderFns } from "./login-form.vue?vue&type=template&id=53952d93&scoped=true"
import script from "./login-form.vue?vue&type=script&lang=js"
export * from "./login-form.vue?vue&type=script&lang=js"
import style0 from "./login-form.vue?vue&type=style&index=0&id=53952d93&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53952d93",
  null
  
)

export default component.exports